module.exports = __webpack_public_path__ + "SamsungOne-200.625bcf580a8cc5be93cf.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungOne-200.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungOne-200.ttf
// module chunks = styles